<h1 mat-dialog-title>Customer Instructions</h1>

<mat-dialog-content>
  <p *ngFor="let guideline of guidelines">
    {{ guideline.acctName + ': ' + guideline.guideline }}
  </p>
</mat-dialog-content>
